import { useEffect, useState } from 'react';

type Variant = 'success' | 'error';

let nextId = 1;
type Listener = (toast: ToastMessage) => void;
const listeners = new Set<Listener>();

export type ToastMessage = {
  id: number;
  text: string;
  variant: Variant;
  durationMs: number;
};

/** Imperative API — fire from anywhere without prop-drilling. */
export function showToast(text: string, opts: { variant?: Variant; durationMs?: number } = {}) {
  const t: ToastMessage = {
    id: nextId++,
    text,
    variant: opts.variant ?? 'success',
    durationMs: opts.durationMs ?? 2200,
  };
  listeners.forEach((l) => l(t));
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const onToast: Listener = (t) => {
      setToasts((cur) => [...cur, t]);
      window.setTimeout(() => {
        setToasts((cur) => cur.filter((x) => x.id !== t.id));
      }, t.durationMs);
    };
    listeners.add(onToast);
    return () => {
      listeners.delete(onToast);
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.variant}`}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
